/**
 * Nearest geo marketing match from visitor coordinates (PROMPT B).
 */
import { haversineKm } from 'shared/utils/geo/haversineKm';
import { listGeoMatchTargets } from './geoMarketingData';
import { geoCityPath, geoCountryPath } from './fusionMsiMarketingRouting';

/** Prefer city match within this radius (km). */
export const GEO_CITY_MATCH_MAX_KM = 75;

/** Fall back to country centroid within this radius (km). */
export const GEO_COUNTRY_MATCH_MAX_KM = 500;

/**
 * @param {{ lat: number, lng: number }} coords
 * @returns {{ label: string, href: string, distanceKm: number } | null}
 */
export function findNearestGeoMarketingMatch(coords) {
  if (!coords || !Number.isFinite(coords.lat) || !Number.isFinite(coords.lng)) {
    return null;
  }

  const targets = listGeoMatchTargets();
  let nearestCity = null;
  let nearestCityKm = Infinity;
  let nearestCountry = null;
  let nearestCountryKm = Infinity;

  targets.forEach((target) => {
    const distanceKm = haversineKm(coords, { lat: target.lat, lng: target.lng });
    if (target.type === 'city' && distanceKm < nearestCityKm) {
      nearestCityKm = distanceKm;
      nearestCity = { ...target, distanceKm };
    }
    if (target.type === 'country' && distanceKm < nearestCountryKm) {
      nearestCountryKm = distanceKm;
      nearestCountry = { ...target, distanceKm };
    }
  });

  if (nearestCity && nearestCityKm <= GEO_CITY_MATCH_MAX_KM) {
    return {
      label: nearestCity.label,
      href: geoCityPath(nearestCity.countrySlug, nearestCity.citySlug),
      distanceKm: nearestCityKm,
    };
  }

  if (nearestCountry && nearestCountryKm <= GEO_COUNTRY_MATCH_MAX_KM) {
    return {
      label: nearestCountry.label,
      href: geoCountryPath(nearestCountry.countrySlug),
      distanceKm: nearestCountryKm,
    };
  }

  return null;
}
